import { FunctionComponent, useLayoutEffect } from "react";
// eslint-disable-next-line @web-monorepo/no-css-file-imports -- DDS global styles for storybook docs
import "../../global.css";

export interface DesignSystemVariablesProps {
  theme?: "light" | "dark";
  brand?: "classdojo" | "tutor" | "islands" | "sparks";
  scoped?: boolean;
  children?: React.ReactNode;
}

export const DesignSystemVariables: FunctionComponent<DesignSystemVariablesProps> = ({
  theme = "light",
  brand = "classdojo",
  scoped = false,
  children,
}) => {
  useLayoutEffect(() => {
    if (scoped) {
      return;
    }

    const previousTheme = document.documentElement.getAttribute("data-theme");
    const previousBrand = document.documentElement.getAttribute("data-brand");

    document.documentElement.setAttribute("data-theme", theme);
    if (brand !== "classdojo") {
      document.documentElement.setAttribute("data-brand", brand);
    } else {
      document.documentElement.removeAttribute("data-brand");
    }

    return () => {
      if (previousTheme) {
        document.documentElement.setAttribute("data-theme", previousTheme);
      } else {
        document.documentElement.removeAttribute("data-theme");
      }

      if (previousBrand) {
        document.documentElement.setAttribute("data-brand", previousBrand);
      } else {
        document.documentElement.removeAttribute("data-brand");
      }
    };
  }, [theme, brand, scoped]);

  if (scoped) {
    return (
      <div data-theme={theme} data-brand={brand !== "classdojo" ? brand : undefined}>
        {children}
      </div>
    );
  }

  return <>{children}</>;
};
